import styled from 'styled-components'

const UploadForm = styled.form`
  margin-bottom: .5em;
`

export default UploadForm
